import Column from '@components/Column';
import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import DeleteAll from './components/DeleteAll';
import PrepaidCardList from './components/PrepaidCardList';
import styles from './styles.module.scss';

const PrepaidCardManageActivity: ActivityComponentType = () => (
        <AppScreen>
            <Column fullWidth className={styles.root}>
                <Header title='선불카드 관리' />
                <DeleteAll/>
                <PrepaidCardList/>
            </Column>
        </AppScreen>
);

export default PrepaidCardManageActivity;
